import { Market } from '@oneaudi/avp-models';
import { Stage } from '@oneaudi/avp-hck-dga-customerui-commons';
import { getStage } from '../../services/StageUtilService';

export const toShortIsoMarketCode = (market: Market): string | undefined => {
  switch (market) {
    case Market.ESP:
      return 'es';
    case Market.DEU:
      return 'de';
    case Market.ITA:
      return 'it';
    case Market.AUS:
      return 'au';
  }

  return undefined;
};

export const toShortIsoLanguageCode = (locale: string): string | undefined => {
  if (!locale.match(/([a-z]{2}[_-])[A-Z]{2}|en/)) {
    return undefined;
  }

  return locale.substring(0, 2);
};

export const saveToMyGarageUrl = (
  market: Market,
  locale: string,
  id: string,
  marketingCode: string,
  dealerId: string,
) => {
  const isoMarket = toShortIsoMarketCode(market);
  const isoLanguage = toShortIsoLanguageCode(locale);
  const host =
    getStage() === Stage.PROD ? `https://www.cupraofficial.com` : 'https://stage.cupraes.seat.com';

  return `${host}/.redirectPage.myConfig.${isoMarket}.${isoLanguage}?marketing-code=${marketingCode}&type=DGA&dealer=${dealerId}&uuid=${id}`;
};

export const isFromMyPrivateArea = (): boolean => {
  const { hash } = window.location;
  if (!hash.includes('?') || hash.split('?').length < 2) {
    return false;
  }
  return new URLSearchParams(hash.split('?').at(1)).get('pa') === 'true';
};
